module.exports = __webpack_public_path__ + "img/BuildingContactDetails.333814cb.png";